import { defineStyleConfig } from '@chakra-ui/system';

export const Skeleton = defineStyleConfig({
    baseStyle: {
        borderRadius: 'base',
        opacity: 0.3,
    },
});
